 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3":"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3","default.json-account~default.json-notifications~views-Book~views-HistoricalData":"default.json-account~default.json-notifications~views-Book~views-HistoricalData","views-Book~views-HistoricalData":"views-Book~views-HistoricalData","views-HistoricalData":"views-HistoricalData","views-ChinaMap":"views-ChinaMap","views-CrossAnalysis":"views-CrossAnalysis","views-Knowledge":"views-Knowledge","views-ProvinceData":"views-ProvinceData","views-QuestionList":"views-QuestionList","views-WorldMap":"views-WorldMap","views-LocalSheet":"views-LocalSheet","views-Nation":"views-Nation","views-NationalSheet":"views-NationalSheet","views-Pie":"views-Pie","views-Sheet":"views-Sheet","views-Book":"views-Book","views-Profile":"views-Profile","layout-default-Index":"layout-default-Index","views-News":"views-News","default.json-app-bar":"default.json-app-bar","default.json-drawer":"default.json-drawer","default.json-view":"default.json-view","default.json-notifications":"default.json-notifications","default.json-account":"default.json-account","default.json-search":"default.json-search","default.json-go-home":"default.json-go-home","default.json-drawer-header":"default.json-drawer-header","default.json-list":"default.json-list"}[chunkId]||chunkId) + "." + {"chunk-a1496f46":"affa25d0","default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3":"5b3fdea7","default.json-account~default.json-notifications~views-Book~views-HistoricalData":"39aadf84","views-Book~views-HistoricalData":"fea0420c","views-HistoricalData":"b7ffb906","views-ChinaMap":"a00baa5e","views-CrossAnalysis":"abfda23d","views-Knowledge":"fdcea988","views-ProvinceData":"104f6c3e","views-QuestionList":"58428ef3","views-WorldMap":"26527580","views-LocalSheet":"2a42ff62","views-Nation":"163a1c11","views-NationalSheet":"e3701868","views-Pie":"d928416c","views-Sheet":"32da5cb8","views-Book":"0c4d58c5","views-Profile":"281238ae","layout-default-Index":"e8c95a12","views-News":"6fb4bf60","default.json-app-bar":"e0e133fd","default.json-drawer":"f091427c","default.json-view":"19d0589a","default.json-notifications":"d33ae34b","default.json-account":"8d0b35ad","default.json-search":"6b6a2c25","default.json-go-home":"ab89412f","default.json-drawer-header":"a94b323f","default.json-list":"5f5849d0","chunk-9d98a2ac":"fd8f44d9","chunk-672247be":"7ccace4a","chunk-2d21e5a6":"75ca0a7e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3":1,"default.json-account~default.json-notifications~views-Book~views-HistoricalData":1,"views-Book~views-HistoricalData":1,"views-HistoricalData":1,"views-ChinaMap":1,"views-CrossAnalysis":1,"views-Knowledge":1,"views-ProvinceData":1,"views-QuestionList":1,"views-WorldMap":1,"views-LocalSheet":1,"views-Nation":1,"views-NationalSheet":1,"views-Sheet":1,"views-Book":1,"views-Profile":1,"layout-default-Index":1,"views-News":1,"default.json-app-bar":1,"default.json-drawer":1,"default.json-view":1,"default.json-notifications":1,"default.json-account":1,"default.json-drawer-header":1,"default.json-list":1,"chunk-9d98a2ac":1,"chunk-672247be":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3":"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3","default.json-account~default.json-notifications~views-Book~views-HistoricalData":"default.json-account~default.json-notifications~views-Book~views-HistoricalData","views-Book~views-HistoricalData":"views-Book~views-HistoricalData","views-HistoricalData":"views-HistoricalData","views-ChinaMap":"views-ChinaMap","views-CrossAnalysis":"views-CrossAnalysis","views-Knowledge":"views-Knowledge","views-ProvinceData":"views-ProvinceData","views-QuestionList":"views-QuestionList","views-WorldMap":"views-WorldMap","views-LocalSheet":"views-LocalSheet","views-Nation":"views-Nation","views-NationalSheet":"views-NationalSheet","views-Pie":"views-Pie","views-Sheet":"views-Sheet","views-Book":"views-Book","views-Profile":"views-Profile","layout-default-Index":"layout-default-Index","views-News":"views-News","default.json-app-bar":"default.json-app-bar","default.json-drawer":"default.json-drawer","default.json-view":"default.json-view","default.json-notifications":"default.json-notifications","default.json-account":"default.json-account","default.json-search":"default.json-search","default.json-go-home":"default.json-go-home","default.json-drawer-header":"default.json-drawer-header","default.json-list":"default.json-list"}[chunkId]||chunkId) + "." + {"chunk-a1496f46":"31d6cfe0","default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3":"c963ff66","default.json-account~default.json-notifications~views-Book~views-HistoricalData":"8fc00739","views-Book~views-HistoricalData":"0a5208be","views-HistoricalData":"a9ed4c54","views-ChinaMap":"398f2f88","views-CrossAnalysis":"97bb6fde","views-Knowledge":"d47409b1","views-ProvinceData":"d68b878b","views-QuestionList":"cdb8f566","views-WorldMap":"86e48f63","views-LocalSheet":"bb9ea5e9","views-Nation":"6d29de95","views-NationalSheet":"6b3bc166","views-Pie":"31d6cfe0","views-Sheet":"61dbc61f","views-Book":"83b9a1b6","views-Profile":"4538fc38","layout-default-Index":"b9bd72a7","views-News":"2030f804","default.json-app-bar":"8ab943e8","default.json-drawer":"7ac7d29c","default.json-view":"68e6a77c","default.json-notifications":"e709eca9","default.json-account":"21204166","default.json-search":"31d6cfe0","default.json-go-home":"31d6cfe0","default.json-drawer-header":"091e2322","default.json-list":"5a23ea0f","chunk-9d98a2ac":"25addafa","chunk-672247be":"25addafa","chunk-2d21e5a6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
